import { QueryParametersState } from "@idw-types/state";
import { QueryParametersActions, QueryParametersActionTypes } from "../actions/query-parameters-actions";
import { RootActions, RootActionTypes } from "../actions/root-actions";

export const initialQueryParametersState: QueryParametersState = {
    token: null,
    asi: null,
    contextPath: null,
    userMessage: null,
    configUrl: null,
    country: null,
	errorCode: null,
	language: null,
	referenceId: null,
	initialized: false,
	apSessionId: null,
	flow: null
};

export const queryParametersReducer = (
	state: QueryParametersState = initialQueryParametersState,
	action: QueryParametersActions | RootActions
) => {
	switch (action.type) {
		case QueryParametersActionTypes.SET_QUERY_PARAMETERS:
			return {
				...state,
				...action.payload.queryParameters
			};
		case RootActionTypes.RESET_STATE:
			return { ...initialQueryParametersState };
		default:
			return state;
	}
};
